import Model, { belongsTo, attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type School from 'district-ui-client/models/school'
import type StringTransform from 'district-ui-client/transforms/string'

export default class ContactDetail extends Model {
  @attr<StringTransform>('string') declare address1: string

  @attr<StringTransform>('string') declare faxNumber: string

  @attr<StringTransform>('string') declare phoneNumber: string

  @attr<StringTransform>('string') declare state: string

  @attr<StringTransform>('string') declare town: string

  @belongsTo<School>('school', { async: false, inverse: 'contactDetail' }) declare school?: School;

  [Type] = 'contact-detail' as const
}
